import { render, staticRenderFns } from "./RmrSlider.vue?vue&type=template&id=44a8ba5a&scoped=true&"
import script from "./RmrSlider.vue?vue&type=script&lang=js&"
export * from "./RmrSlider.vue?vue&type=script&lang=js&"
import style0 from "./RmrSlider.vue?vue&type=style&index=0&id=44a8ba5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a8ba5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VSlider})
